import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";

interface AppDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  actions: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  /** Show close (X) icon in header */
  showCloseIcon?: boolean;
}

/**
 * Standard app dialog with consistent styling (title, dividers, content, actions).
 * Use for all modal dialogs to keep UI consistent.
 */
export default function AppDialog({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "xs",
  showCloseIcon = false,
}: AppDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <span>{title}</span>
          {showCloseIcon && (
            <IconButton onClick={onClose} size="small" aria-label="Close">
              <Close />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>{children}</DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 2 }}>{actions}</DialogActions>
    </Dialog>
  );
}
